import React from "react";
import Spinner from "Components/RequestHandler/Spinner";

// Fills the player's reserved aspect-ratio box while the video initializes —
// course art dimmed behind a spinner, never empty space.
const VideoPlayerSkeleton = ({ thumbnail }) => {
  return (
    <div className="absolute inset-0 bg-grey/40 motion-safe:animate-pulse">
      {thumbnail && (
        <img
          src={thumbnail}
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
      )}
      <div className="absolute inset-0 flex items-center justify-center bg-black/30">
        <Spinner isWhite />
      </div>
    </div>
  );
};

export default VideoPlayerSkeleton;
